<template>
  <div class="coocaa-static-plugin-loader" :class="{ 'plugin-error': isError }">
    <div class="plugin-tip" v-if="tipMsg">{{ tipMsg }}</div>
    <micro-app
      v-if="!isError"
      :name='name'
      :url='url'
      :data="appData"
      @datachange="handleDataChange"
      @mounted="handleMounted"
      @error="handleError">
    </micro-app>
  </div>
</template>
<script>
import microApp from '@micro-zoe/micro-app'
import { getPluginOptions } from '../utils/pluginOptions'
import { API_PREFIX_MAP } from '../utils/constant'
import { genRandom } from '../utils/common'
export default {
  name: 'StaticPluginLoader',
  props: {
    // 插件唯一ID
    name: {
      type: String
      // required: true,
      // default: `${genRandom()}`
    },
    // 插件加载地址
    url: {
      type: String,
      required: true
    },
    // 插件属性
    pluginProps: {
      type: Object,
      default () {
        return {}
      }
    },
    // 插件事件
    pluginEvents: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      pluginComponentInstance: undefined, // 外部只能在 mounted 阶段才能获取到该变量
      isError: false,
      tipMsg: '插件加载中，请稍后！',
      plginData: undefined,
      pluginOptions: undefined // { loaderOptions, pluginInfo, apiPrefixMap }
    }
  },
  computed: {
    appName () {
      return `${this.name}_${genRandom()}`
    },
    appData () {
      return {
        props: this.pluginProps,
        event: this.pluginEvents,
        data: this.plginData,
        options: this.pluginOptions // { loaderOptions, pluginInfo, apiPrefixMap }
      }
    }
  },
  watch: {
    appData (v) {
      // 发送数据给子应用
      microApp.setData(this.appName, v)
    },
    isError (isError) {
      if (isError) {
        this.$emit('error', this.tipMsg)
      }
    }
  },
  methods: {
    handleDataChange (e) {
      const data = e.detail.data || {}
      const { componentInstance } = data
      this.pluginComponentInstance = componentInstance
    },
    handleMounted () {
      this.tipMsg = ''
      this.$emit('mounted')
    },
    handleError (e) {
      this.isError = true
      this.tipMsg = '插件渲染失败，请检查！'
      console.error('插件渲染失败，', e)
    },
    triggerAppEvent (event, ...params) {
      if (this.pluginComponentInstance) {
        return this.pluginComponentInstance[event](...params)
      }
    }
  },
  created () {
    this.pluginOptions = {
      apiPrefixMap: API_PREFIX_MAP, // 插件接口代理
      loaderOptions: getPluginOptions() // 加载器初始化时配置信息
    }
  }
}
</script>
<style scoped>
.coocaa-static-plugin-loader .plugin-tip {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 10px;
  color: #909399;
}
.coocaa-static-plugin-loader.plugin-error .plugin-tip {
  color: #F56C6C;
  border-color: #F56C6C;
}
</style>
